export default __webpack_public_path__ + "44f535a5014b1147f5d47a4fcdb6125b.mtl";